import { getConfig, Env } from '@magicdoorinc/env';
import { renderContext } from '~/platform/renderContext';

type EnvConfig = ReturnType<typeof getConfig>;

const currentHostname = (): string | undefined => {
  const pageUrl = renderContext.pageUrl();
  return pageUrl ? new URL(pageUrl).hostname : undefined;
};

export const getEnv = (): Env => {
  if (import.meta.env.DEV) {
    return (import.meta.env.DEBUG_ENV as Env | undefined) ?? Env.Test;
  }
  const hostname = currentHostname();
  if (hostname?.includes('-test.com')) {
    return Env.Test;
  }
  if (hostname?.includes('magicdoor.dev')) {
    return Env.Dev;
  }
  if (hostname?.includes('-demo.com')) {
    return Env.Demo;
  }
  return Env.Production;
};

const configs = new Map<Env, EnvConfig>();

export const getEnvConfig = (): EnvConfig => {
  const env = getEnv();
  let config = configs.get(env);
  if (!config) {
    config = getConfig(() => env);
    configs.set(env, config);
  }
  return config;
};
